import { $api } from "../generated/client";

export default function useGetPayementIntent(
	shopId: string,
	paymentIntentId: string,
) {
	return $api.useQuery(
		"get",
		"/shops/{shopId}/integrations/stripe/payment-intent/{paymentIntentId}",
		{
			params: { path: { shopId, paymentIntentId } },
		},
		{
			refetchOnWindowFocus: "always",
		},
	);
}
